<template>
  <div class="page">
    <div class="title mgb15">导入商品信息</div>
    <div class="title2 mgb15">第一步，先导入商品，商品必须使用spuid导入，可在商品列表查看，导入方式可选择直接输入id导入也可以使用模版导入，最多一次性可导入100个</div>
    <div class="mgb15">
      <el-input type="textarea" v-model="productIds" placeholder="请使用spuid”,”隔开，最多可导入100个商品"></el-input>
    </div>
    <div class="mgb15">
      <el-button type="primary" @click="confirmImport">确认导入</el-button>
      <!-- <el-button type="primary">Excel导入</el-button> -->
    </div>
    <div class="title mgb15">快捷操作</div>
    <div class="title2 mgb15">
      第二步，针对导入的商品进行批量修改，可修改对应的商品标题，补充说明；也可修改对应分销渠道的某个规格，选择后对应同分销渠道同规格名称的价格或库存会依据修改后一键覆盖，分销渠道与规格需同时填写才可生效。覆盖后无法撤回，请谨慎操作！
    </div>
    <div class="flex-wrap flex-center mgb15">
      <span style="width: 90px">商品标题：</span>
      <el-input style="width: 300px;" v-model="productName"></el-input>
      <el-button class="mgl20" type="primary" @click="coverProductName">全部覆盖</el-button>
    </div>
    <div class="flex-wrap flex-center mgb15">
      <span style="width: 90px">补充说明：</span>
      <el-input style="width: 300px;" v-model="serviceContent"></el-input>
      <el-button class="mgl20" type="primary" @click="coverServiceContent">全部覆盖</el-button>
    </div>
    <div class="flex-wrap mgb15">
      <div class="flex-wrap flex-center">
        <span>分销商名称：</span>
        <el-select v-model="resellerName" @change="changeReseller" value-key="resellerId">
          <el-option v-for="(item, index) in resellerList" :key="index" :label="item.resellerName"
            :value="item"></el-option>
        </el-select>
        <!-- <el-input v-model="resellerName"></el-input> -->
      </div>
      <div class="flex-wrap flex-center mgl20">
        <span>规格名称：</span>
        <el-select v-model="propertyDisplayExt">
          <el-option v-for="(item, index) in propertyList" :key="index" :label="item.propertyDisplayExt"
            :value="item.propertyDisplayExt"></el-option>
        </el-select>
        <!-- <el-input v-model="propertyDisplayExt"></el-input> -->
      </div>
      <!-- <el-button type="primary">查询</el-button> -->
    </div>
    <div class="mgb15">
      <el-table border :data="setList">
        <el-table-column label="供货价" align="center">
          <template slot-scope="scope">
            <el-input v-model="scope.row.supplyPrice"></el-input>
          </template>
        </el-table-column>
        <!-- <el-table-column label="商家价" align="center">
          <template slot-scope="scope">
            <el-input v-if="priceType==1" disabled v-model="scope.row.supplyPrice"></el-input>
            <el-input v-else v-model="scope.row.merchantsPrice"></el-input>
          </template>
        </el-table-column> -->
        <el-table-column label="零售价" align="center">
          <template slot-scope="scope">
            <el-input v-if="priceType == 1" disabled v-model="scope.row.supplyPrice"></el-input>
            <el-input v-else v-model="scope.row.retailPrice"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="市场价" align="center">
          <template slot-scope="scope">
            <el-input v-if="priceType == 1" disabled v-model="scope.row.supplyPrice"></el-input>
            <el-input v-else v-model="scope.row.marketPrice"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="销售库存" align="center">
          <template slot-scope="scope">
            <el-input v-model="scope.row.defaultStock"></el-input>
          </template>
        </el-table-column>
        <!-- <el-table-column label="区域库存" align="center"><el-input></el-input></el-table-column> -->
      </el-table>
    </div>
    <div class="mgb15">
      <el-button type="primary" @click="coverPrice">全部覆盖</el-button>
    </div>
    <div id="table-box">
      <el-table border :data="tableList" :span-method="arraySpanMethod" :cell-class-name="setCellStyle">
        <el-table-column label="商品Id" prop="productId" align="center" width="100"></el-table-column>
        <el-table-column label="商品标题" align="center" min-width="120">
          <template slot-scope="scope">
            <el-input type="textarea" v-model="scope.row.productName"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="补充说明" align="center" min-width="120">
          <template slot-scope="scope">
            <el-input type="textarea" v-model="scope.row.serviceContent"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="分销商名称" align="center" min-width="120">
          <template slot-scope="scope">
            <el-table :data="scope.row.items" :show-header="false" :span-method="arraySpanMethod1"
              :cell-class-name="setCellStyle1">
              <el-table-column prop="resellerName" align="center" min-width="119"></el-table-column>
              <el-table-column align="center">
                <template slot-scope="scope1">
                  <el-table border :data="scope1.row.items" :show-header="false">
                    <el-table-column prop="propertyDisplayExt" align="center"></el-table-column>
                    <el-table-column align="center">
                      <template slot-scope="scope2">
                        <el-input v-model="scope2.row.supplyPrice" @change="changeInput(scope1.row, scope2.row)"
                          placeholder="请输入"></el-input>
                      </template>
                    </el-table-column>
                    <!-- <el-table-column align="center">
                      <template slot-scope="scope2">
                        <el-input v-model="scope2.row.supplyPrice"  @change="changeInput(scope1.row, scope2.row)" placeholder="请输入"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column align="center">
                      <template slot-scope="scope2">
                        <el-input v-model="scope2.row.merchantsPrice" v-if="scope1.row.priceType==1" disabled placeholder="请输入"></el-input>
                        <el-input v-model="scope2.row.merchantsPrice" v-else placeholder="请输入"></el-input>
                      </template>
                    </el-table-column> -->
                    <el-table-column align="center">
                      <template slot-scope="scope2">
                        <el-input v-model="scope2.row.retailPrice" v-if="scope1.row.priceType == 1" disabled
                          placeholder="请输入"></el-input>
                        <el-input v-model="scope2.row.retailPrice" v-else placeholder="请输入"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column align="center">
                      <template slot-scope="scope2">
                        <el-input v-model="scope2.row.marketPrice" v-if="scope1.row.priceType == 1" disabled
                          placeholder="请输入"></el-input>
                        <el-input v-model="scope2.row.marketPrice" v-else placeholder="请输入"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column align="center">
                      <template slot-scope="scope2">
                        <el-input v-model="scope2.row.defaultStock"></el-input>
                      </template>
                    </el-table-column>
                    <!-- <el-table-column align="center">
                      <template slot-scope="scope2">
                        <el-input v-model="scope2.row.defaultStock"></el-input>
                      </template>
                    </el-table-column> -->
                  </el-table>
                </template>
              </el-table-column>
              <el-table-column align="center"></el-table-column>
              <el-table-column align="center"></el-table-column>
              <el-table-column align="center"></el-table-column>
              <el-table-column align="center"></el-table-column>
              <el-table-column align="center"></el-table-column>
              <!-- <el-table-column align="center"></el-table-column> -->
            </el-table>
          </template>
        </el-table-column>
        <el-table-column label="规格名称" align="center"></el-table-column>
        <el-table-column label="供货价" align="center"><el-input></el-input></el-table-column>
        <!-- <el-table-column label="销售价" align="center"><el-input></el-input></el-table-column> -->
        <!-- <el-table-column label="商家价" align="center"><el-input></el-input></el-table-column> -->
        <el-table-column label="零售价" align="center"><el-input></el-input></el-table-column>
        <el-table-column label="市场价" align="center"><el-input></el-input></el-table-column>
        <el-table-column label="销售库存" align="center"><el-input></el-input></el-table-column>
        <!-- <el-table-column label="区域库存" align="center"><el-input></el-input></el-table-column> -->
      </el-table>
    </div>
    <div style="text-align: center;margin-top:20px;">
      <el-button type="primary" @click="submitUpdateInfo">同步并上架</el-button>
    </div>
    <el-dialog :visible.sync="dialogErrorMsg">
      <p v-for="(item, index) in errorMsg" :key="index">{{ item }}</p>
    </el-dialog>
    <!-- 错误提示 -->
    <el-dialog title="提示" :visible.sync="errVisible" width="30%" :before-close="handleClose">
      <div v-html="errHtml"></div>
    </el-dialog>
  </div>
</template>

<script>
import {
  GetHandyUpdateList,
  ExcuteHandyUpdate,
  GetProhibitedList
} from '../../../api/api'
export default {
  data() {
    return {
      productIds: '',
      productName: null,
      serviceContent: null,
      resellerId: null,
      resellerName: null,
      priceType: null,
      propertyDisplayExt: null,
      setList: [{
        supplyPrice: null,
        merchantsPrice: null,
        retailPrice: null,
        marketPrice: null,
        defaultStock: null
      }],
      tableList: [],
      resellerProperty: [],
      ishave: [],
      dialogErrorMsg: false,
      errorMsg: [],
      errVisible: false,
      errHtml: ''
    }
  },
  created() {
    // this.getHandyUpdateList()
  },
  computed: {
    resellerList() {
      let arr = []
      this.tableList.forEach(item => {
        item.items.forEach(val => {
          arr.push({
            resellerId: val.resellerId,
            resellerName: val.resellerName,
            priceType: val.priceType
          })
        })
      })
      let obj = {}
      arr = arr.reduce((item, next) => {
        obj[next.resellerId] ? '' : obj[next.resellerId] = true && item.push(next)
        return item
      }, [])
      return arr
    },
    propertyList() {
      let arr = []
      this.tableList.forEach(item => {
        item.items.forEach(val => {
          val.items.forEach(v => {
            arr.push({
              propertyDisplayExt: v.propertyDisplayExt,
              // resellerId: val.resellerId
            })
          })
        })
      })
      let obj = {}
      arr = arr.reduce((item, next) => {
        obj[next.propertyDisplayExt] ? '' : obj[next.propertyDisplayExt] = true && item.push(next)
        return item
      }, [])
      return arr
    },
  },
  methods: {
    changeInput(row1, row2) {
      row2.merchantsPrice = row2.supplyPrice
      if (row1.priceType == 1) {
        row2.retailPrice = row2.supplyPrice
        row2.marketPrice = row2.supplyPrice
      }
    },
    changeReseller(val) {
      // this.resellerProperty = []
      // this.propertyDisplayExt = null
      this.resellerId = val.resellerId
      this.resellerName = val.resellerName
      this.priceType = val.priceType
      // this.resellerProperty = this.propertyList.filter(item => {
      //   return item.resellerId == val.resellerId
      // })
    },
    coverProductName() {
      if (!this.productName) {
        return this.$message.error('请输入要覆盖的内容！')
      }
      this.$confirm("确认覆盖吗?", "提示", {
        type: "warning",
        closeOnClickModal: false,
      }).then(() => {
        this.tableList.forEach(item => {
          item.productName = this.productName
        })
        this.$message.success('覆盖成功！')
      }).catch(() => { });
    },
    coverServiceContent() {
      if (!this.serviceContent) {
        return this.$message.error('请输入要覆盖的内容！')
      }
      this.$confirm("确认覆盖吗?", "提示", {
        type: "warning",
        closeOnClickModal: false,
      }).then(() => {
        this.tableList.forEach(item => {
          item.serviceContent = this.serviceContent
        })
        this.$message.success('覆盖成功！')
      }).catch(() => { });
    },
    coverPrice() {
      if (!this.resellerId || !this.propertyDisplayExt) {
        return this.$message.error('请先填写要覆盖的分销商和规格！')
      }
      let flag = this.setList.every(val => {
        return !val.supplyPrice && !val.merchantsPrice && !val.retailPrice && !val.marketPrice && !val.defaultStock
      })
      if (flag) {
        return this.$message.error('请填写要覆盖的价格或库存！')
      }
      if (this.priceType == 1) {
        this.setList.forEach(item => {
          item.retailPrice = item.supplyPrice
          item.marketPrice = item.supplyPrice
          item.merchantsPrice = item.supplyPrice
        })
      }
      let setPrice = this.setList[0]
      this.$confirm("确认覆盖吗?", "提示", {
        type: "warning",
        closeOnClickModal: false,
      }).then(() => {
        this.ishave = []
        this.tableList.forEach(item => {
          item.items.forEach(val => {
            if (val.resellerName == this.resellerName) {
              let flage = val.items.some(s => {
                return s.propertyDisplayExt == this.propertyDisplayExt
              })
              this.ishave.push(flage)
            }
          })
        })
        let isShow = this.ishave.some(m => {
          return m
        })
        if (!isShow) {
          return this.$message.error('未找到您选择的内容！')
        } else {
          this.tableList.forEach(item => {
            item.items.forEach(val => {
              if (val.resellerName == this.resellerName) {
                this.ishave = val.items.some(s => {
                  return s.propertyDisplayExt == this.propertyDisplayExt
                })
                val.items.forEach(v => {
                  if (v.propertyDisplayExt == this.propertyDisplayExt) {
                    v.supplyPrice = setPrice.supplyPrice ? setPrice.supplyPrice : v.supplyPrice
                    v.retailPrice = setPrice.retailPrice ? setPrice.retailPrice : v.retailPrice
                    v.marketPrice = setPrice.marketPrice ? setPrice.marketPrice : v.marketPrice
                    v.merchantsPrice = setPrice.merchantsPrice ? setPrice.merchantsPrice : v.merchantsPrice
                    v.defaultStock = setPrice.defaultStock ? setPrice.defaultStock : v.defaultStock
                  }
                })
              }
            })
          })
          this.$message.success('覆盖成功！')
        }
      }).catch(() => { });
    },
    confirmImport() {
      this.getHandyUpdateList()
    },
    getHandyUpdateList() {
      let data = {
        ProductIds: this.productIds
      }
      GetHandyUpdateList(data).then(res => {
        if (res.data.success) {
          this.tableList = res.data.result || []
        }
      })
    },
    async submitUpdateInfo() {
      let list = []
      this.tableList.forEach(item => {
        item.items.forEach(val => {
          val.arr = []
          val.items.forEach(v => {
            val.arr.push({
              resellerId: val.resellerId,
              saleableSkuId: v.saleableSkuId,
              costPrice: v.costPrice,
              marketPrice: v.marketPrice,
              merchantsPrice: v.merchantsPrice,
              retailPrice: v.retailPrice,
              supplyPrice: Number(v.supplyPrice),
              defaultStock: v.defaultStock
            })
          })
          list.push({
            productId: item.productId,
            productName: item.productName,
            serviceContent: item.serviceContent,
            items: val.arr,
            model: item.model
          })
        })
      })
      this.errHtml = ''
      const vRes = await GetProhibitedList({ modelCode: this.tableList.map(i => i.model).join(',') })
      const data = vRes.data.result
      if (data && data.length) {
        let errList = []
        // 判断是不是有少于最低价格
        for (var m = 0; m < data.length; m++) {
          let model = data[m].modelCode
          let minPrice = data[m].minPrice
          let tData = list.find(i => i.model == model)
          for (var i = 0; i < tData.items.length; i++) {
            if (tData.items[i].supplyPrice <= minPrice) {
              errList.push(`<p>很抱歉，因厂家限制要求，spuid:<span style="color:Red">${tData.productId}</span>,型号<span style="color:Red">${tData.model}</span>价格不可低于<span style="color:Red">¥${minPrice}</span>,请修改后重新操作！</p>`)
            }
          }
        }
        if (errList.length) {
          this.errHtml = errList.join('')
          this.errVisible = true
          return
        }
      }
      this.$confirm("确认同步并上架吗?", "提示", {
        type: "warning",
        closeOnClickModal: false,
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在同步，请不要关闭页面！',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        let data = {
          isSyncPush: true,
          items: list
        }
        ExcuteHandyUpdate(data).then(res => {
          if (res.data.success) {
            loading.close();
            if (res.data.result) {
              this.dialogErrorMsg = true
              this.errorMsg = res.data.result.split(';')
            } else {
              this.$message.success('操作成功！')
            }
          } else {
            loading.close();
            this.$message.error(res.data.error.message)
          }
        })
      }).catch(() => { });
    },
    setCellStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 3) {
        return "buyStyle";
      }
    },
    setCellStyle1({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1) {
        return "buyStyle";
      }
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 3) {
        return [1, 8];
      } else if (columnIndex === 4) {
        return [0, 0];
      } else if (columnIndex === 5) {
        return [0, 0];
      } else if (columnIndex === 6) {
        return [0, 0];
      } else if (columnIndex === 7) {
        return [0, 0];
      } else if (columnIndex === 8) {
        return [0, 0];
      } else if (columnIndex === 9) {
        return [0, 0];
      } else if (columnIndex === 10) {
        return [0, 0];
      }
    },
    arraySpanMethod1({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1) {
        return [1, 7];
      } else if (columnIndex === 2) {
        return [0, 0];
      } else if (columnIndex === 3) {
        return [0, 0];
      } else if (columnIndex === 4) {
        return [0, 0];
      } else if (columnIndex === 5) {
        return [0, 0];
      } else if (columnIndex === 6) {
        return [0, 0];
      } else if (columnIndex === 7) {
        return [0, 0];
      }
    },
  }
}
</script>

<style scoped>
/* .page{
  padding: 0 20px;
} */
.mgb15 {
  margin-bottom: 15px;
}

.mgl20 {
  margin-left: 20px;
}

.flex-wrap {
  display: flex;
}

.flex-center {
  align-items: center;
}

.title {
  font-size: 20px;
  font-weight: 700;
}

.title2 {
  background: #F2F6FC;
  color: #909399;
  padding: 10px;
  font-size: 13px;
}

#table-box /deep/ .buyStyle {
  padding: 0 !important;
}

#table-box /deep/.buyStyle .cell {
  padding: 0 !important;
}</style>